import React, { createContext, useContext, useState } from "react";
import { CMS_SESSION_KEY } from "../../shared/apiClient";

const AuthContext = createContext(undefined);

function readSessionFromStorage() {
  try {
    const raw = localStorage.getItem(CMS_SESSION_KEY);
    if (!raw) {
      return { user: null, token: null };
    }
    const stored = JSON.parse(raw);
    if (stored.expiresAt && new Date(stored.expiresAt) < new Date()) {
      localStorage.removeItem(CMS_SESSION_KEY);
      return { user: null, token: null };
    }
    return { user: stored.user ?? null, token: stored.token ?? null };
  } catch {
    try {
      localStorage.removeItem(CMS_SESSION_KEY);
    } catch {
      /* ignore */
    }
    return { user: null, token: null };
  }
}

export const AuthProvider = ({ children }) => {
  const [state, setState] = useState(() => readSessionFromStorage());

  const user = state.user;
  const token = state.token;

  const login = (nextUser, nextToken, expiresAt) => {
    const session = {
      user: nextUser,
      token: nextToken,
      expiresAt
    };
    setState({ user: nextUser, token: nextToken });
    localStorage.setItem(CMS_SESSION_KEY, JSON.stringify(session));
  };

  const logout = () => {
    setState({ user: null, token: null });
    try {
      localStorage.removeItem(CMS_SESSION_KEY);
    } catch {
      /* ignore */
    }
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return ctx;
};
